import { faCheck, faClose, faCalendarDays, faEyeSlash, faChartPie } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import { useGetStudentSessionsMutation } from '../../../../../features/authentication/classesApiSlice';
import { selectFerpaState } from '../../../../../features/authentication/authSlice';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ClassManagementProvider } from '../../ClassManagement/utils/classManagementContext';
import { useClassManagementContext } from '../../ClassManagement/utils/classManagementContext';
import { useSelector } from 'react-redux';
import { SortUtils } from '../../../../../utils/sorting';
import TableSkeleton from '../../../../../components/SkeletonLoader/TableSkeleton';
import { faChartLineUp, faCircleQuestion, faUserTimes } from '@fortawesome/pro-solid-svg-icons';
import CustomToast from '../../../../../components/Toast';
import { NavLink } from 'react-router-dom';

const SessionsAndReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showRemoved, setShowRemoved] = useState(false);
  const [sortColumn, setSortColumn] = useState('lName');
  const [sortDirection, setSortDirection] = useState('asc');
  const [sessionReportData, setSessionReportData] = useState([]);
  const [getStudentSession] = useGetStudentSessionsMutation();
  const { selectedClassId, selectedCourseId, selectedCustomCourseId } = useClassManagementContext();
  const ferpaEnabled = useSelector(selectFerpaState);

  useEffect(() => {
    if (selectedClassId > 0 && selectedCourseId != 0)
      getStudentSessionReportAsync();
  }, [selectedClassId, selectedCourseId]);

  const getStudentSessionReportAsync = async () => {
    setSessionReportData([]);
    setIsLoading(true);
    const options = {
      classId: selectedClassId,
      courseId: selectedCourseId === 255 ? selectedCustomCourseId : selectedCourseId
    };
    const response = await getStudentSession(options);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Name, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    }
    else if (response.data) {
      setSessionReportData(response.data);
    }
    setIsLoading(false);
  };

  const renderSortIcons = (column) => {
    return (SortUtils.renderSortIcons(sortDirection, sortColumn, column));
  };

  const handleSort = async (column) => {
    let sortedData = [];
    var direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    if (sortDirection === 'asc')
      sortedData = SortUtils.customSort(sessionReportData, column, true);
    else
      sortedData = SortUtils.customSort(sessionReportData, column, false);
    setSessionReportData(sortedData);
  };

  return (
    <ClassManagementProvider>
      <div>
        <div className="row message-tab align-items-center mb-3">
          <div className='d-flex justify-content-end'>
            <NavLink to={`/classes/${selectedClassId}/${selectedCourseId}/classCumulativeReport`} className="col-xl-3 text-end text-castleRed cursor-pointer cumulative-report-title px-2 text-decoration-none">
              <FontAwesomeIcon className='px-1' icon={faChartPie} />
              Class Cumulative Report
            </NavLink>
          </div>
          <div className='d-flex justify-content-between mb-4'>
            <div>
              Number Of students <span className="rounded-number mx-1 fw-semibold">{sessionReportData.length}</span>
            </div>
            <div>
              <input
                type="checkbox"
                className="form-check-input me-2 cursor-pointer"
                checked={showRemoved}
                id="flexCheckDefault"
                name="allselect"
                onChange={() => setShowRemoved(!showRemoved)}
              />
              <label className="form-check-label">
                Display Removed Students
              </label>
              <OverlayTrigger
                key="label-info"
                placement="top"
                overlay={
                  <Tooltip id="parent-tooltip" className="image-info-tooltip">
                    <p>Removed students include those that are Hidden (by teacher), Disabled (by district), or Deactivated (based on account activity or manual deactivation)</p>
                  </Tooltip>
                }>
                <FontAwesomeIcon icon={faCircleQuestion} className="circle-question mx-1" />
              </OverlayTrigger>
            </div>
          </div>
          <div className="custom-table table-responsive">
            {!isLoading && sessionReportData?.length > 0 &&
              <>
                <table className='table reportTable w-100'>
                  <thead className="thead-light align-middle">
                    <tr>
                      <th></th>
                      <th scope="col" className={`fw-medium  min-w-150 ${ferpaEnabled && 'cursor-pointer'}`} onClick={() => ferpaEnabled && handleSort('lName')}>
                        <span className='align-items-center d-flex justify-content-between'> <span>Last Name</span> {ferpaEnabled && renderSortIcons('lName')} </span>
                      </th>
                      <th scope="col" className={`fw-medium  min-w-150 ${ferpaEnabled && 'cursor-pointer'}`} onClick={() => ferpaEnabled && handleSort('fName')}>
                        <span className='align-items-center d-flex justify-content-between'> <span>First Name</span> {ferpaEnabled && renderSortIcons('fName')} </span>
                      </th>
                      {selectedCourseId === -1 &&
                        <th scope="col" className='fw-medium cursor-pointer min-w-150' onClick={() => handleSort('courseName')}>
                          <span className='align-items-center d-flex justify-content-between'> <span>Course Name</span> {renderSortIcons('courseName')} </span>
                        </th>
                      }
                      <th scope="col" className='fw-medium cursor-pointer min-w-150' onClick={() => handleSort('sessionCount')}>
                        <span className='align-items-center d-flex justify-content-between'> <span>Sessions</span> {renderSortIcons('sessionCount')} </span>
                      </th>
                      <th scope="col" className='fw-medium cursor-pointer min-w-150' onClick={() => handleSort('correct')}>
                        <span className='align-items-center d-flex justify-content-between'> <span><FontAwesomeIcon icon={faCheck} /></span> {renderSortIcons('correct')} </span>
                      </th>
                      <th scope="col" className='fw-medium cursor-pointer min-w-150' onClick={() => handleSort('inCorrect')}>
                        <span className='align-items-center d-flex justify-content-between'> <span><FontAwesomeIcon icon={faClose} /></span> {renderSortIcons('inCorrect')} </span>
                      </th>
                      <th scope="col" className='fw-medium cursor-pointer min-w-150' onClick={() => handleSort('correctOnRetry')}>
                        <span className='align-items-center d-flex justify-content-between'> <span><FontAwesomeIcon icon={faClose} /><FontAwesomeIcon icon={faCheck} /></span> {renderSortIcons('correctOnRetry')} </span>
                      </th>
                      <th scope="col" className='fw-medium cursor-pointer min-w-150' onClick={() => handleSort('crAnswered')}>
                        <span className='align-items-center d-flex justify-content-between'> <span>CR Answered</span> {renderSortIcons('crAnswered')} </span>
                      </th>
                      <th scaope='col' className='min-w-150'></th>
                    </tr>
                  </thead>
                  {!isLoading &&
                    <>
                      {
                        <tbody>
                          {sessionReportData?.map((item, index) => (
                            <>
                              {(!item.isDeleted || (showRemoved && item.isDeleted)) &&
                                <tr key={`${item.studentId}-record`}>
                                  <td>
                                    {item.isDeleted &&
                                      <OverlayTrigger
                                        key="hidden"
                                        placement="top"
                                        overlay={<Tooltip className="custom-tooltip">Hidden
                                        </Tooltip>}>
                                        <div className='hiddenStudent'>
                                          <FontAwesomeIcon icon={faEyeSlash} className='p-1' />
                                        </div>
                                      </OverlayTrigger>
                                    }
                                    {item.isDeactive &&
                                      <OverlayTrigger
                                        key="deactivated"
                                        placement="top"
                                        overlay={<Tooltip className="custom-tooltip">Deactivated
                                        </Tooltip>}>
                                        <div className='deactiveStudent'>
                                          <FontAwesomeIcon icon={faUserTimes} className='p-1' />
                                        </div>
                                      </OverlayTrigger>
                                    }
                                  </td>
                                  {ferpaEnabled ? <td>{item.lName}</td> : <td>Lastname<br></br>hidden</td>}
                                  {ferpaEnabled ? <td>{item.fName}</td> : <td>Firstname<br></br>hidden</td>}
                                  {selectedCourseId === -1 && <td>{item.courseName}</td>}
                                  <td>{item.sessionCount}</td>
                                  <td>{item.correct}</td>
                                  <td>{item.inCorrect}</td>
                                  <td>{item.correctOnRetry}</td>
                                  <td>{item.crAnswered}</td>
                                  <td>
                                    <div className='d-flex flex-row'>{item.sessionCount > 0 &&
                                      <NavLink to={`/classes/${selectedClassId}/${item.studentId}/${item.courseId}/viewSessions`}>
                                        <OverlayTrigger
                                          key="viewSessions"
                                          placement="top"
                                          overlay={<Tooltip className="custom-tooltip">View Sessions</Tooltip>}>
                                          <button
                                            id={'viewSessions' + index}
                                            className='action-btn-tile blue'
                                          >
                                            <FontAwesomeIcon icon={faCalendarDays} />
                                          </button>
                                        </OverlayTrigger>
                                      </NavLink>
                                    }
                                      {(item.correct + item.inCorrect + item.correctOnRetry > 0) &&
                                        <NavLink to={`/classes/${selectedClassId}/${selectedCourseId}/${item.studentId}/studentCumulativeReport`}>
                                          <OverlayTrigger
                                            key="studentCumulativeReport"
                                            placement="top"
                                            overlay={<Tooltip className="custom-tooltip">Student Cumulative Report</Tooltip>}>
                                            <button
                                              id={'studentcumulativeReport' + index}
                                              className='action-btn-tile blue'
                                            >
                                              <FontAwesomeIcon icon={faChartLineUp} />
                                            </button>
                                          </OverlayTrigger>
                                        </NavLink>
                                      }
                                    </div>
                                  </td>
                                </tr>
                              }
                            </>
                          ))}
                        </tbody>
                      }
                    </>}
                </table>
              </>}
            {isLoading &&
              <TableSkeleton
                colCount={8}
                rowCount={4} />
            }
          </div>
        </div>
        <Outlet />
      </div>
    </ClassManagementProvider>
  );
};

export default SessionsAndReport;